import script from "./FavoriteFlag.vue?vue&type=script&setup=true&lang=ts"
export * from "./FavoriteFlag.vue?vue&type=script&setup=true&lang=ts"

import "./FavoriteFlag.vue?vue&type=style&index=0&id=9fa1694e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fa1694e"]])

export default __exports__